module.exports = __webpack_public_path__ + "static/media/Zoom In.fbde7e74.svg";